import { DateTime } from "luxon";

/**
 * Retourne le nombre d'utilisateurs inscrits par jour, séparés par role (étudiant, alumni)
 *
 * Une entrée est crée pour chaque jour, même si aucun utilisateur ne s'est inscrit ce jour là.
 *
 * Les 30 derniers jours sont affichés sous format MM-DD. (Rajouter l'année rend le graphique illisible)
 *
 * @param {UserRegistrationDate[]} usersByRegistrationDate - Nombre d'utilisateurs inscrits par jour
 * @return {NivoBarChartData} - données formatées pour le graphique
 */
export const getUsersCountByRegistrationDateData = (
  usersByRegistrationDate
) => {
  /** @type {NivoBarChartData} */
  let chartData = [];

  //? Pour chaque jour on créé un objet avec le nom de la catégorie et le nombre d'offres associées
  for (const userRegistrationDate of usersByRegistrationDate) {
    chartData.push({
      Date: userRegistrationDate.date,
      //? Convertit les valeurs en nombre si elles sont de type string
      Étudiants: Number(userRegistrationDate.totalStudents),
      Alumni: Number(userRegistrationDate.totalAlumni),
    });
  }

  //? Pour chaque jour (dans les 30 derniers jours) on crée une entrée dans le tableau chartData avec des totaux à 0
  //? si aucune donnée n'est présente pour ce jour
  for (let i = 0; i < 30; i++) {
    const date = DateTime.local().minus({ days: i });
    //? Affiche les nombres sur 2 chiffres
    const stringDate =
      String(date.month).padStart(2, "0") +
      "-" +
      String(date.day).padStart(2, "0");
    if (!chartData.find((e) => e.date === stringDate)) {
      chartData.push({
        Date: stringDate,
        Étudiants: 0,
        Alumni: 0,
      });
    }
  }

  //? On trie les données par date croissante 08-01, 08-02, 08-03, etc.
  chartData.sort((a, b) => {
    return (
      Number(a.Date.split("-")[0]) - Number(b.Date.split("-")[0]) ||
      Number(a.Date.split("-")[1]) - Number(b.Date.split("-")[1])
    );
  });

  return chartData;
};

/**
 * Fonction formatant les données pour le graphique des utilisateurs inscrits par mois
 *
 * @param {Object[]} usersCount - Nombre d'utilisateurs inscrits par mois
 * @param {string} usersCount[].date - Date en YYYY-MM
 * @param {number} usersCount[].total - Nombre d'utilisateurs inscrits cette date
 * @returns {NivoBarChartData} - données formatées pour le graphique
 */
export const getUsersCountByMonthData = (usersCount) => {
  /** @type {NivoBarChartData} */
  let chartData = [];

  //? Pour chaque mois on créé un objet avec le nom de la catégorie et le nombre d'offres associées
  for (const userCount of usersCount) {
    chartData.push({
      Date: userCount.date,
      //? Convertit les valeurs en nombre si elles sont de type string
      Utilisateurs: Number(userCount.total),
    });
  }

  //? On trie les données par date croissante
  chartData.sort((a, b) => {
    return new Date(a.date) - new Date(b.date);
  });

  return chartData;
};
